export const navItems = [
  // {
  //   name: "Chart",
  //   to: "/chart",
  //   svg: (
  //     <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
  //       <path
  //         d="M17.6751 13.2416C17.1449 14.4953 16.3157 15.6001 15.2599 16.4594C14.2042 17.3186 12.954 17.9061 11.6187 18.1706C10.2835 18.4351 8.90374 18.3684 7.60017 17.9764C6.29661 17.5845 5.10891 16.8792 4.1409 15.9222C3.1729 14.9651 2.45406 13.7856 2.04725 12.4866C1.64043 11.1876 1.55802 9.80868 1.80722 8.47047C2.05641 7.13226 2.62963 5.87547 3.47676 4.80997C4.32388 3.74447 5.41912 2.90271 6.66672 2.35828"
  //         strokeWidth="2"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //       <path
  //         d="M18.3333 9.99996C18.3333 8.90561 18.1178 7.82198 17.699 6.81093C17.2802 5.79988 16.6664 4.88122 15.8926 4.1074C15.1187 3.33358 14.2001 2.71975 13.189 2.30096C12.178 1.88217 11.0943 1.66663 10 1.66663V9.99996H18.3333Z"
  //         strokeWidth="2"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
  {
    name: "Tables",
    to: "/tables",
    path: ["/order", "/ongoing-orders", "/table-view", "/pay-later-view"],
    sideHeaders: ["Order", "Ongoing Order", "Table View", "Pay Later"],
    svg: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path
          d="M14.8333 1.5H3.16667C2.24619 1.5 1.5 2.24619 1.5 3.16667V14.8333C1.5 15.7538 2.24619 16.5 3.16667 16.5H14.8333C15.7538 16.5 16.5 15.7538 16.5 14.8333V3.16667C16.5 2.24619 15.7538 1.5 14.8333 1.5Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5 6.5H16.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 16.5V6.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Customers",
    to: "/customers",
    svg: (
      <svg width="20" height="18" viewBox="0 0 20 18" fill="none">
        <path
          d="M14.1667 16.5V14.8333C14.1667 13.9493 13.8155 13.1014 13.1904 12.4763C12.5653 11.8512 11.7174 11.5 10.8334 11.5H4.16671C3.28265 11.5 2.43481 11.8512 1.80968 12.4763C1.18456 13.1014 0.833374 13.9493 0.833374 14.8333V16.5"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.49996 8.16667C9.34091 8.16667 10.8333 6.67428 10.8333 4.83333C10.8333 2.99238 9.34091 1.5 7.49996 1.5C5.65901 1.5 4.16663 2.99238 4.16663 4.83333C4.16663 6.67428 5.65901 8.16667 7.49996 8.16667Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.1666 16.4999V14.8333C19.1661 14.0947 18.9203 13.3773 18.4678 12.7935C18.0153 12.2098 17.3817 11.7929 16.6666 11.6083"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.3334 1.60828C14.0504 1.79186 14.6859 2.20886 15.1397 2.79354C15.5936 3.37821 15.8399 4.0973 15.8399 4.83744C15.8399 5.57759 15.5936 6.29668 15.1397 6.88135C14.6859 7.46603 14.0504 7.88303 13.3334 8.06661"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    name: "Products",
    to: "/products",
    path: ["/manage-category", "/manage-product", "/manage-addon"],
    sideHeaders: ["Manage Category", "Manage Product", "Manage Addon"],
    svg: (
      <svg width="18" height="20" viewBox="0 0 18 20" fill="none">
        <path
          d="M12.75 7.83379L5.25 3.50879"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 13.3329V6.66626C16.4997 6.37399 16.4225 6.08693 16.2763 5.83389C16.13 5.58086 15.9198 5.37073 15.6667 5.22459L9.83333 1.89126C9.57997 1.74498 9.29256 1.66797 9 1.66797C8.70744 1.66797 8.42003 1.74498 8.16667 1.89126L2.33333 5.22459C2.08022 5.37073 1.86998 5.58086 1.72372 5.83389C1.57745 6.08693 1.5003 6.37399 1.5 6.66626V13.3329C1.5003 13.6252 1.57745 13.9122 1.72372 14.1653C1.86998 14.4183 2.08022 14.6285 2.33333 14.7746L8.16667 18.1079C8.42003 18.2542 8.70744 18.3312 9 18.3312C9.29256 18.3312 9.57997 18.2542 9.83333 18.1079L15.6667 14.7746C15.9198 14.6285 16.13 14.4183 16.2763 14.1653C16.4225 13.9122 16.4997 13.6252 16.5 13.3329Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.7251 5.7998L9.0001 10.0081L16.2751 5.7998"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 18.4V10"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  // {
  //   name: "Vendors",
  //   to: "/vendors",
  //   path: ["/vendor-management", "/purchase-order"],
  //   sideHeaders: ["Vendor Management", "Purchase Order"],
  //   svg: (
  //     <svg width="18" height="20" viewBox="0 0 18 20" fill="none">
  //       <path
  //         d="M4 1.66663L1.5 4.99996V16.6666C1.5 17.1087 1.67559 17.5326 1.98816 17.8451C2.30072 18.1577 2.72464 18.3333 3.16667 18.3333H14.8333C15.2754 18.3333 15.6993 18.1577 16.0118 17.8451C16.3244 17.5326 16.5 17.1087 16.5 16.6666V4.99996L14 1.66663H4Z"
  //         strokeWidth="2"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //       <path
  //         d="M1.5 5H16.5"
  //         strokeWidth="2"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //       <path
  //         d="M12.3332 8.33337C12.3332 9.21743 11.982 10.0653 11.3569 10.6904C10.7317 11.3155 9.88389 11.6667 8.99984 11.6667C8.11578 11.6667 7.26794 11.3155 6.64281 10.6904C6.01769 10.0653 5.6665 9.21743 5.6665 8.33337"
  //         strokeWidth="2"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //     </svg>
  //   ),
  // },
  {
    name: "Kitchen",
    to: "/kitchen",
    svg: (
      <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M11 13.5C12.3807 13.5 13.5 12.3807 13.5 11C13.5 9.61929 12.3807 8.5 11 8.5C9.61929 8.5 8.5 9.61929 8.5 11C8.5 12.3807 9.61929 13.5 11 13.5Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path 
        d="M17.1668 13.5C17.0559 13.7514 17.0228 14.0302 17.0718 14.3005C17.1208 14.5709 17.2497 14.8203 17.4418 15.0167L17.4918 15.0667C17.6468 15.2215 17.7697 15.4053 17.8536 15.6076C17.9375 15.81 17.9806 16.0268 17.9806 16.2459C17.9806 16.4649 17.9375 16.6818 17.8536 16.8841C17.7697 17.0864 17.6468 17.2702 17.4918 17.425C17.337 17.58 17.1532 17.7029 16.9509 17.7868C16.7486 17.8707 16.5317 17.9139 16.3127 17.9139C16.0936 17.9139 15.8768 17.8707 15.6744 17.7868C15.4721 17.7029 15.2883 17.58 15.1335 17.425L15.0835 17.375C14.8871 17.1829 14.6376 17.0541 14.3673 17.005C14.097 16.956 13.8182 16.9891 13.5668 17.1C13.3204 17.2057 13.1101 17.3811 12.9621 17.6047C12.814 17.8282 12.7346 18.0902 12.7335 18.3584V18.5C12.7335 18.9421 12.5579 19.366 12.2453 19.6785C11.9328 19.9911 11.5089 20.1667 11.0668 20.1667C10.6248 20.1667 10.2009 19.9911 9.88832 19.6785C9.57576 19.366 9.40016 18.9421 9.40016 18.5V18.425C9.39371 18.1492 9.30443 17.8817 9.14392 17.6573C8.98341 17.4329 8.75911 17.2619 8.50016 17.1667C8.24882 17.0558 7.97 17.0227 7.69967 17.0717C7.42934 17.1207 7.17989 17.2496 6.9835 17.4417L6.9335 17.4917C6.77871 17.6467 6.59489 17.7696 6.39256 17.8535C6.19023 17.9373 5.97335 17.9805 5.75433 17.9805C5.5353 17.9805 5.31843 17.9373 5.1161 17.8535C4.91377 17.7696 4.72995 17.6467 4.57516 17.4917C4.4202 17.3369 4.29727 17.1531 4.2134 16.9508C4.12952 16.7484 4.08635 16.5316 4.08635 16.3125C4.08635 16.0935 4.12952 15.8766 4.2134 15.6743C4.29727 15.472 4.4202 15.2882 4.57516 15.1334L4.62516 15.0834C4.81728 14.887 4.94615 14.6375 4.99517 14.3672C5.04418 14.0969 5.01109 13.8181 4.90016 13.5667C4.79453 13.3202 4.61913 13.11 4.39555 12.962C4.17198 12.8139 3.90998 12.7344 3.64183 12.7334H3.50016C3.05814 12.7334 2.63421 12.5578 2.32165 12.2452C2.00909 11.9327 1.8335 11.5087 1.8335 11.0667C1.8335 10.6247 2.00909 10.2008 2.32165 9.8882C2.63421 9.57563 3.05814 9.40004 3.50016 9.40004H3.57516C3.85099 9.39359 4.1185 9.30431 4.34291 9.1438C4.56732 8.98329 4.73826 8.75899 4.8335 8.50004C4.94443 8.24869 4.97752 7.96988 4.9285 7.69955C4.87948 7.42922 4.75061 7.17977 4.5585 6.98337L4.5085 6.93337C4.35354 6.77858 4.2306 6.59477 4.14673 6.39244C4.06286 6.19011 4.01968 5.97323 4.01968 5.75421C4.01968 5.53518 4.06286 5.3183 4.14673 5.11597C4.2306 4.91364 4.35354 4.72983 4.5085 4.57504C4.66328 4.42008 4.8471 4.29715 5.04943 4.21327C5.25176 4.1294 5.46864 4.08623 5.68766 4.08623C5.90669 4.08623 6.12357 4.1294 6.3259 4.21327C6.52823 4.29715 6.71204 4.42008 6.86683 4.57504L6.91683 4.62504C7.11323 4.81715 7.36268 4.94603 7.633 4.99504C7.90333 5.04406 8.18215 5.01097 8.4335 4.90004H8.50016C8.74664 4.7944 8.95684 4.619 9.10491 4.39543C9.25297 4.17185 9.33243 3.90986 9.3335 3.64171V3.50004C9.3335 3.05801 9.50909 2.63409 9.82165 2.32153C10.1342 2.00897 10.5581 1.83337 11.0002 1.83337C11.4422 1.83337 11.8661 2.00897 12.1787 2.32153C12.4912 2.63409 12.6668 3.05801 12.6668 3.50004V3.57504C12.6679 3.8432 12.7474 4.10519 12.8954 4.32876C13.0435 4.55234 13.2537 4.72774 13.5002 4.83337C13.7515 4.9443 14.0303 4.97739 14.3007 4.92838C14.571 4.87936 14.8204 4.75049 15.0168 4.55837L15.0668 4.50837C15.2216 4.35341 15.4054 4.23048 15.6078 4.14661C15.8101 4.06273 16.027 4.01956 16.246 4.01956C16.465 4.01956 16.6819 4.06273 16.8842 4.14661C17.0866 4.23048 17.2704 4.35341 17.4252 4.50837C17.5801 4.66316 17.7031 4.84698 17.7869 5.04931C17.8708 5.25164 17.914 5.46851 17.914 5.68754C17.914 5.90657 17.8708 6.12344 17.7869 6.32577C17.7031 6.5281 17.5801 6.71192 17.4252 6.86671L17.3752 6.91671C17.183 7.11311 17.0542 7.36255 17.0052 7.63288C16.9561 7.90321 16.9892 8.18203 17.1002 8.43337V8.50004C17.2058 8.74651 17.3812 8.95672 17.6048 9.10478C17.8283 9.25285 18.0903 9.3323 18.3585 9.33337H18.5002C18.9422 9.33337 19.3661 9.50897 19.6787 9.82153C19.9912 10.1341 20.1668 10.558 20.1668 11C20.1668 11.4421 19.9912 11.866 19.6787 12.1786C19.3661 12.4911 18.9422 12.6667 18.5002 12.6667H18.4252C18.157 12.6678 17.895 12.7472 17.6714 12.8953C17.4479 13.0434 17.2725 13.2536 17.1668 13.5V13.5Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    ),
  },
];


export const reportsNavObject = {
    name: "Reports",
    to: "/report",
    svg: (
      <svg
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
      >
        <path
          d="M9.66683 1.66663H3.00016C2.55814 1.66663 2.13421 1.84222 1.82165 2.15478C1.50909 2.46734 1.3335 2.89127 1.3335 3.33329V16.6666C1.3335 17.1087 1.50909 17.5326 1.82165 17.8451C2.13421 18.1577 2.55814 18.3333 3.00016 18.3333H13.0002C13.4422 18.3333 13.8661 18.1577 14.1787 17.8451C14.4912 17.5326 14.6668 17.1087 14.6668 16.6666V6.66663L9.66683 1.66663Z"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.6665 1.66663V6.66663H14.6665"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3332 10.8334H4.6665"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3332 14.1666H4.6665"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.33317 7.5H5.49984H4.6665"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  }
